import React from 'react';
import { useApp } from '../../context/AppContext';
import { Avatar } from '../ui/Avatar';
import { fmtDate } from '../../utils/format';

// Who's out today — from the server summary, so it matches the dashboard
// figures, the calendar header and the mobile app. Absences only (working
// from home isn't "out"); colleagues' leave shows as "Away" unless you
// approve it or are HR. Managers see their own team.
export function WhosOut() {
  const { summary, getEmployee } = useApp();
  const out = summary?.outToday;
  const people = out?.people ?? [];
  const teamOnly = out?.scope === 'team';

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold th-text">{teamOnly ? 'Out today in your team' : "Who's out today"}</h3>
        <span className="text-xs th-muted">{summary ? `${people.length} away` : ''}</span>
      </div>
      {!summary ? (
        <p className="text-sm th-muted text-center py-4">Loading…</p>
      ) : people.length === 0 ? (
        <p className="text-sm th-muted text-center py-4">Everyone's in today.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {people.map(p => {
            const emp = getEmployee(p.empId) ?? { id: p.empId, name: p.name };
            return (
              <div key={p.empId} className="flex items-center gap-3">
                <Avatar employee={emp} size="sm" />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p className="text-sm font-medium th-text truncate">{p.name}</p>
                  <p className="text-xs th-muted truncate">
                    {p.label}{p.halfDay ? ` · ${p.halfDay === 'AM' ? 'morning' : 'afternoon'}` : ` · until ${fmtDate(p.until, { weekday: true })}`}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}